import {
  dataToHump
} from '@packages/utils'

// 数据转驼峰
export default function (data) {
  if (data && typeof data === 'object') {
    return dataToHump(data)
  }
  return data
}



// WEBPACK FOOTER //
// ./src/packages/plugins/src/axios/src/transformResponse/src/hump.js